import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";
import { authApi } from "@/api/auth";

// Landing page hit by the browser after the OAuth callback redirected us back
// to the SPA with the access token in the URL fragment.
export function OAuthReturnPage() {
  const nav = useNavigate();
  const clear = useAuthStore((s) => s.clear);

  useEffect(() => {
    const frag = window.location.hash.startsWith("#")
      ? window.location.hash.slice(1)
      : window.location.hash;
    const params = new URLSearchParams(frag);

    // Second facteur actif: le serveur n'a PAS ouvert de session, il rend un defi. Meme
    // chemin que la connexion par mot de passe -- le magasin porte le jeton temporaire et
    // l'ecran /login/2fa le consomme. Sans ca, le 2FA ne protegeait que le mot de passe:
    // qui prenait le compte Google lie entrait sans jamais presenter son second facteur.
    const temp = params.get("temp_token");
    if (temp) {
      clear();
      useAuthStore.setState({ pending2FA: { tempToken: temp } });
      history.replaceState({}, "", window.location.pathname);
      nav("/login/2fa", { replace: true });
      return;
    }

    const access = params.get("access_token");
    if (!access) {
      clear();
      nav("/login?oauth_error=missing_access_token", { replace: true });
      return;
    }
    useAuthStore.setState({ accessToken: access });
    // Clear the fragment from the address bar so a reload does not re-process.
    history.replaceState({}, "", window.location.pathname);
    authApi.me().then((user) => {
      useAuthStore.setState({ user });
      nav("/projects", { replace: true });
    }).catch(() => {
      clear();
      nav("/login?oauth_error=me_failed", { replace: true });
    });
  }, [nav, clear]);

  return (
    <div className="flex h-dvh flex-col items-center justify-center gap-4 bg-ef-bg text-sm text-ef-textDim">
      <span className="h-8 w-8 animate-spin rounded-full border-2 border-ef-border border-t-ef-accent" />
      Completing sign-in…
    </div>
  );
}
